import * as cn from "classnames";
import * as React from "react";
import * as ReimgixComponent from "reimgix";
import * as styles from "./styles.css";
// Something is up with how they export this thing...
var Reimgix = typeof ReimgixComponent === "object" ? ReimgixComponent.default : ReimgixComponent;
var ListItemImage = function (_a) {
    var src = _a.src, width = _a.width, height = _a.height, alt = _a.alt, className = _a.className;
    var inBrowser = typeof window !== "undefined";
    return (React.createElement(Reimgix, { lqipParams: {
            blur: "200",
            px: 0,
        }, params: {
            fit: "crop",
            h: height,
            w: width,
        }, src: src }, function (_a) {
        var image = _a.src;
        return (React.createElement("img", { className: cn(styles.listItemImage, className), src: image, alt: alt || "" }));
    }));
};
export default ListItemImage;



//////////////////
// WEBPACK FOOTER
// ./app/modules/search/components/listItemImage/index.tsx
// module id = RrWA
// module chunks = 2